import { genres } from "@/mocks/narutoData";
import SectionHeading from "./SectionHeading";

export default function GenreSection() {
  return (
    <section id="genre" className="scroll-mt-20 bg-background-100/60 py-16 md:py-24">
      <div className="mx-auto max-w-[1200px] px-4 md:px-6">
        <SectionHeading
          eyebrow="题材分类"
          title="长篇短篇、甜虐热血尽在其中"
          desc="无论你想看环环相扣的长篇正剧，还是轻松治愈的日常短篇，按题材分类都能帮你精准找到心头好。"
        />

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
          {genres.map((g) => (
            <article
              key={g.id}
              className="group flex items-center gap-4 rounded-lg border border-background-200 bg-background-50 p-5 transition-colors hover:border-primary-500/50"
            >
              <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-lg bg-primary-500/10 text-primary-500">
                <i className="ri-quill-pen-fill text-xl" />
              </span>
              <div className="flex-1">
                <div className="flex items-center justify-between">
                  <h3 className="font-heading text-base font-bold text-foreground-950">{g.name}</h3>
                  <span className="text-xs text-foreground-500">{g.count} 篇</span>
                </div>
                <p className="mt-1 text-xs leading-relaxed text-foreground-500">{g.desc}</p>
              </div>
              <i className="ri-arrow-right-s-line text-lg text-foreground-500 transition-transform group-hover:translate-x-1 group-hover:text-primary-500" />
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}